import React from "react";
import MUIFormControl from "@mui/material/FormControl";
import MUIFormHelperText from "@mui/material/FormHelperText";
import MUIFormLabel from "@mui/material/FormLabel";
import { extractFormFieldError, getClassName } from "@sscs/utils";
import { Controller, useFormContext, } from "react-hook-form";
import { Select } from "../../index";
import { useControlSize } from "../formDense";
import { useRegisterRequiredField } from "../requiredFields";
import styles from "./dropdownMenu.module.scss";
function DropdownMenu({ isFullWidth = false, isRequired, children, ...props }) {
    const { control } = useFormContext();
    const resolvedSize = useControlSize(props.size);
    useRegisterRequiredField(isRequired !== null && isRequired !== void 0 ? isRequired : false);
    const { errorMessage, hasError } = extractFormFieldError(props.name, props === null || props === void 0 ? void 0 : props.errors);
    const dropdownMenuClassName = getClassName(styles["form-control"], props.className, {
        [styles.isFullWidth]: isFullWidth,
    });
    return (React.createElement(Controller, { control: control, name: props.name, render: ({ field }) => { var _a; return (React.createElement(MUIFormControl, { className: dropdownMenuClassName, disabled: props.isDisabled },
            props.label && (React.createElement(MUIFormLabel, { required: isRequired, htmlFor: props.id || props.name }, props.label)),
            React.createElement(Select, { ...field, id: props.id, name: field.name, value: field.value, disabled: props.isDisabled, isFullWidth: isFullWidth, size: resolvedSize, "aria-label": (_a = props.label) !== null && _a !== void 0 ? _a : props["aria-label"], onChange: (value) => {
                    var _a;
                    field.onChange(value);
                    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, value);
                } }, children),
            props.helperText && (React.createElement(MUIFormHelperText, null, props.helperText)),
            hasError && (React.createElement(MUIFormHelperText, { error: true }, errorMessage)))); } }));
}
export default DropdownMenu;
//# sourceMappingURL=DropdownMenu.js.map